
/**
 * 플랜 상태
 */
export type GetPlanChangeOptions200UpgradeOptionsItemStatus = typeof GetPlanChangeOptions200UpgradeOptionsItemStatus[keyof typeof GetPlanChangeOptions200UpgradeOptionsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanChangeOptions200UpgradeOptionsItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
